import React, { Component } from 'react';
import { Button, Col, Container, Row } from 'reactstrap';
import { Redirect } from 'react-router-dom';

import { LogoHeader } from '../../../containers/Components/index'

import instagram_square from '../../../assets/img/instagram-square.png';


class Training extends Component {
  constructor(props) {
    super(props);
    this.state = {
      login: false,
      signup: false,
      warning: "",
      showVerify: false,
      html_btn_status: 0,
    };
    this.user_name = "";
    this.pwd = "";
  }

  renderRedirect = () => {
    if (this.state.login) {
      return <Redirect to= { '/login/'} />
    }
    if (this.state.signup) {
      return <Redirect to= { '/register/'} />
    }
  }
  render() {

    // let slider_count = 4;
    // if (window.innerWidth < 520) {
    //   slider_count = 4;
    // }

    return (
      <div className="app flex-row font-Poppins">
      {this.renderRedirect()}
        <React.Fragment>
        <LogoHeader />
        
        <div className="app-body p-0 m-0 width-100vw mt-5 ">
            <Container className = "background-white" fluid>
               <Row className = "about_page_gradient mt-3 ">
                 <Col className = "d-md-down-none" xs="6" sm="6" lg="2">
                 </Col>
                 <Col xs="6" sm="6" lg="2">
                  <h5 className = "m-3 text-white"> Training </h5>
                 </Col>
                </Row>
                <Row>
                  <Col className = "d-md-down-none" xs="6" sm="6" lg="2">
                  </Col>
                  <Col xs="12" sm="12" lg="8">
                    <h6 className = "mt-5 pt-2 line-height-h">
                        XR (Extended Reality) technology is revolutionizing enterprise training by providing immersive and 
                        effective learning experiences. Here are some real-life use cases that showcase the value of XR in 
                        enterprise training:

                        <h6 className = "mt-4 line-height-h">

                        <b> a. Safety and Hazard Training:</b> XR enables employees to undergo safety training in simulated 
                        environments. For instance, workers in high-risk industries like construction can practice safety 
                        protocols, identify hazards, and respond to emergencies in realistic virtual scenarios, 
                        reducing real-world risks.
                        <br></br>
                        <b> b. Equipment Operation and Maintenance:</b> XR allows employees to learn how to operate and maintain 
                        complex machinery and equipment. They can interact with virtual representations of machinery, 
                        disassemble and reassemble components, and practice troubleshooting, leading to enhanced proficiency 
                        and reduced downtime.
                        <br></br>
                        <b> c. Customer Service and Sales Training:</b> XR facilitates immersive training for customer service 
                        and sales teams. Employees can engage in simulated customer interactions, hone their communication skills, 
                        and learn effective sales techniques in virtual environments, improving their performance in real-world 
                        scenarios.
                        <br></br>
                        <b> d. Remote Collaboration and Training:</b> XR connects geographically dispersed teams by providing 
                        virtual collaboration platforms. Employees can collaborate, train, and solve problems together in 
                        shared virtual spaces, promoting teamwork and knowledge sharing regardless of physical location.
                        <br></br>
                        <b> e. Soft Skills Development:</b> XR can help employees develop essential soft skills like public 
                        speaking, leadership, and teamwork. They can engage in virtual simulations of presentations, team projects, 
                        and challenging workplace scenarios, fostering confidence and improving interpersonal abilities.
                        <br></br>
                        <b> f. Onboarding and New Employee Training:</b> XR simplifies the onboarding process by providing 
                        immersive experiences for new employees. They can familiarize themselves with the company culture, 
                        navigate virtual office spaces, and learn about organizational policies and procedures, accelerating 
                        their integration into the workforce.
                      </h6>
                      <h6 className = "mt-5 pt-2 line-height-h">
                        These practical use cases illustrate how XR transforms enterprise training, offering engaging, realistic, 
                        and cost-effective learning solutions. By harnessing XR technology, organizations can improve employee 
                        performance, reduce training costs, and enhance overall productivity, creating a skilled and capable 
                        workforce ready to tackle real-world challenges.                    
                      </h6>
                     </h6>
                  </Col>  
                  <Col className = "d-md-down-none" xs="6" sm="6" lg="2">
                  </Col>
                </Row>
{/* -------------- Footer Start -------- */}
                <Row className="mt-5">
                </Row>
                <Row className="pt-5 pb-5 home-background-gray">
                  <Col xs="0" sm="0" lg="1">
                  </Col>
                  <Col xs="4" sm="4" lg="2">
                    <Row className = "ml-2 text-left">
                      <Col className="mt-5 mb-4" md = '12'> 
                        <div>PRODUCT</div>
                      </Col>
                      <Col className="mb-2 text-secondary" md = '12'> 
                         <a href = "/feature"><div className = "font-size-10" >Features & Roadmap</div></a>
                      </Col>
                      <Col className="mb-2 text-secondary" md = '12'> 
                        <a href = "/appguide"><div className = "font-size-10" >Solutions</div></a>
                      </Col>
                      <Col className = "mb-2 text-secondary"  md = '12'> 
                        <a href = "/customdev"><div className = "font-size-10" >Professional Services</div></a>
                      </Col>
                      <Col className = "mb-2 text-secondary"  md = '12'> 
                        <a href = "/pricing"><div className = "font-size-10" >Pricing</div></a>
                      </Col>
                    </Row>
                  </Col>
                  <Col xs="4" sm="4" lg="2">
                    <Row className = "text-left ml-2">
                      <Col className="mt-5 mb-4" md = '12'> 
                        <div >USE CASES</div>
                      </Col>
                      <Col className = "mb-2 text-secondary" md = '12'> 
                        <a href = "/education"><div className = "font-size-10" >Education</div></a>
                      </Col>
                      <Col className = "mb-2 text-secondary" md = '12'> 
                        <a href = "/training"><div className = "font-size-10" >Training</div></a>
                      </Col>
                      <Col className = "mb-2 text-secondary" md = '12'> 
                        <a href = "/retail"><div className = "font-size-10" >Retail</div></a>
                      </Col>
                      <Col className = "mb-2 text-secondary" md = '12'> 
                        <a href = "/ecommerce"><div className = "font-size-10" >Ecommerce</div></a>
                      </Col>
                    </Row>
                  </Col>
                  <Col xs="4" sm="4" lg="2">
                    <Row className = "text-left ml-2">
                      <Col className="mt-5 mb-4" md = '12'> 
                        <div>Support</div>
                      </Col>
                      <Col className="mb-2 text-secondary" md = '12'> 
                        <a href = "http://www.icomputinglabs.in/blog/" target="_blank" rel="noopener noreferrer">
                        <div className = "font-size-10" >Blog</div> </a>
                      </Col>
                      <Col className="mb-2 text-secondary" md = '12'> 
                        <a href = "/faq"><div className = "font-size-10" >FAQ</div></a>
                      </Col>
                      <Col className = "mb-2 text-secondary" md = '12'> 
                        <a href = "/contact"><div className = "font-size-10" >Contact</div></a>
                      </Col>
                    </Row>
                  </Col>
                  <Col xs="6" sm="6" lg="2">
                    <Row className = "text-left ml-2">
                      <Col className="mt-5 mb-4" md = '12'> 
                        <div>COMPANY</div>
                      </Col>
                      <Col className="mb-2 text-secondary" md = '12'> 
                        <a href = "/about"><div className = "font-size-10" >About</div></a>
                      </Col>
                      <Col className="mb-2 text-secondary" md = '12'> 
                        <a href = "/privacy"><div className = "font-size-10" >Privacy Policy</div></a>
                      </Col>
                      <Col className = "mb-2 text-secondary" md = '12'> 
                        <a href = "/tos"><div className = "font-size-10" >Terms of Service</div></a>
                      </Col>
                    </Row>
                  </Col>
                  <Col xs="6" sm="6" lg="2">
                    <Row className = "text-left ml-2">
                      <Col className="mt-5 mb-4" md = '12'> 
                        <div>GET CONNECTED</div>
                      </Col>
                      <Col className="mb-2 text-secondary" md = '12'> 
                        <a href = "https://www.facebook.com/icomputinglabs/" target="_blank" rel="noopener noreferrer">
                        <div className = "font-size-10" ><i className = "text-primary fa fa-facebook-square fa-lg mr-2" />facebook</div>
                        </a>
                      </Col>
                      <Col className="mb-2 text-secondary" md = '12'> 
                        <a href = "https://www.instagram.com/icomputinglabs/" target="_blank" rel="noopener noreferrer">
                        <div className = "font-size-10" ><img  alt="" src={instagram_square} className = "text-primary width-16 mr-2" />instagram</div>
                        </a>
                      </Col>
                      <Col className = "mb-2 text-secondary"  md = '12'> 
                        <a href = "https://twitter.com/iComputingLabs" target="_blank" rel="noopener noreferrer">
                        <div className = "font-size-10" ><i className = "text-primary fa fa-twitter-square fa-lg mr-2" />twitter</div>
                        </a>
                      </Col>
                      <Col className = "mb-2 text-secondary"  md = '12'>
                        <a href = "https://www.linkedin.com/company/13404850/" target="_blank" rel="noopener noreferrer">
                        <div className = "font-size-10" ><i className = "text-primary fa fa-linkedin-square fa-lg mr-2" />linkedin</div>
                        </a>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              {/* -------------- Footer End -------- */}
  
            </Container>
        </div>
        </React.Fragment>
      </div>
    );
  }
}

export default Training;



// WEBPACK FOOTER //
// ./src/views/Pages/Training/Training.js